{
  "id": "dionysus",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Dionísio",
    "en": "Dionysus"
  },
  "icon": "gods/dionysus",
  "portrait": "gods/dionysus-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "hydra": 1
  },
  "unlocks": ["hydra", "chthonic-rites", "dionysia", "thracian-horses"],
  "powers": ["bronze"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "HeroicAgeDionysus: CreateUnit Hydra at a Temple (one free myth unit), god power Bronze (cooldown 150 s); enables the listed unit and techs."
  }
}
